<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>Feriados</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="obterFeriados()"
                            ></i>
                        </span>
                    </div>
                </h4>
                <app-tabela
                    :itens="feriados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-feriados></btn-inserir-feriados>
                        </b-button-group>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('ADMIN-FERIADOS-00')">
                            <btn-atualizar-feriados
                            :feriado="data"
                            class="fa fa-edit fa-lg icon-button">
                            </btn-atualizar-feriados>
                            <btn-ativar-desativar-feriado
                            :feriado="data"
                            @obterFeriados="obterFeriados()">

                            </btn-ativar-desativar-feriado>
                            <btn-excluir-feriado
                            :feriado="data"
                            @obterFeriados="obterFeriados()">
                            </btn-excluir-feriado>
                        </span>
                    </template>
                    <template slot="dataFeriado" slot-scope="data">
                        {{ data.dataFeriado ? $moment(data.dataFeriado).format('DD/MM/YYYY') : ''}}
                    </template>
                    <template slot="descricao" slot-scope="data">
                        <span class="text-nowrap">
                            {{data.descricao}}</span>
                    </template>
                    <template slot="ativo" slot-scope="data">
                        <app-status :status="data.ativo == true ? 'ATIVO' : 'INATIVO'"></app-status>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import FeriadosServicos from './FeriadosServicos'
import BtnInserirFeriados from './BtnInserirFeriados'
import BtnExcluirFeriado from './BtnExcluirFeriado.vue'
import BtnAtualizarFeriados from './BtnAtualizarFeriados.vue'
import BtnAtivarDesativarFeriado from './BtnAtivarDesativarFeriado.vue'

export default {
    props: {
    },

    data() {
        return {
            feriados: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'dataFeriado',
                    label: 'Data',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'descricao',
                    label: 'Nome Feriado',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ativo',
                    label: 'Ativado/Desativado',
                    sortable: true,
                    filterable: true
                },
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterFeriados() {
            this.$store.dispatch('addRequest')
            FeriadosServicos.obterTodos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.feriados = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter feriados',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        toDetalhar(feriadoId) {
            this.$router.push({
                name: 'Feriado_Detalhar',
                params: {
                    feriadoId: feriadoId
                }
            })
        }
    },

    created() {
        this.obterFeriados()
    },

    computed: {
        mostrarTabela() {
            return (
                this.$route.name == 'Feriados'
            )
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Feriados') {
                if (this.$store.getters.recarregar) {
                    this.obterFeriados()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    components: {
        BtnInserirFeriados,
        BtnExcluirFeriado,
        BtnAtualizarFeriados,
        BtnAtivarDesativarFeriado
    }
}
</script>
